<template>
  <ElForm
    class="w-full"
    label-position="top"
    require-asterisk-position="right"
    @submit.prevent
  >
    <ElAlert v-if="errorMsg" type="error" class="mb-5" show-icon>{{ errorMsg }}</ElAlert>

    <ElFormItem
      label="E-Mail Adresse"
      for="email"
      class="mb-3"
      :error="errors.email?.[0]"
    >
      <ElInput
        id="email"
        v-model="form.email"
        type="email"
        :disabled="loading"
        autocomplete="email"
        required
      />
    </ElFormItem>

    <ElFormItem
      label="Passwort"
      for="Passwort"
      :error="errors.password?.[0]"
    >
      <ElInput
        id="Passwort"
        v-model="form.password"
        name="password"
        :disabled="loading"
        autocomplete="current-password"
        required
        type="password"
        show-password
      />
    </ElFormItem>

    <ElButton
      class="mt-1 w-full"
      text
      @click="handleSwitchToEmail"
    >
      {{ params.redirect ? 'Noch kein Passwort gesetzt?' : 'Passwort vergessen?' }}
    </ElButton>

    <div class="mt-6 lg:mt-10 space-y-2">
      <AppButton
        native-type="submit"
        type="primary"
        class="w-full"
        size="large"
        :handler="submit"
      >
        Anmelden
      </AppButton>
      <div class="max-lg:hidden text-muted text-center">Oder</div>
      <AppButton
        :disabled="loading"
        type="primary"
        plain
        class="w-full"
        size="large"
        @click="handleSwitchToEmail"
      >
        Ohne Passwort anmelden
      </AppButton>
    </div>
  </ElForm>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert, ElButton, ElForm, ElFormItem, ElInput } from 'element-plus';
import { onMounted } from 'vue';

import { TrackEventCategory } from '@/application/utils/tracking/events';

import { useForm } from "@/api/lib/integration";
import { passwordLogin } from "@/api/auth/authApi";
import { getDeviceName, isNativePlatform } from "@/application/utils/envInfo";
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { useUrlSearchParams } from '@vueuse/core'

const emit = defineEmits(['switch-to-mail', 'two-factor-challenge']);

const params = useUrlSearchParams('history')

const { form , errors, submit, errorMsg, loading } = useForm(
  passwordLogin,
  { email: '', password: '' },
  async (requestAccessToken) => {
    emit('two-factor-challenge', requestAccessToken);
  }
);

defineExpose({ form, errors });

function handleSwitchToEmail() {
  emit('switch-to-mail');
  useTagManager().push({ event: TrackEventCategory.LOGIN_VIA_MAIL, action: 'zur E-Mail Anmeldung' })
}

onMounted(async () => {
  if (isNativePlatform) {
    // @ts-ignore
    form.value.deviceName = await getDeviceName();
  }
})
</script>
